
    <div class="confirm-dialog" fxLayout="column" fxLayoutAlign="space-between">
      <div class="mat-title">{{ 'confirm' | translate | titlecase }}</div>
      <div class="mat-subheading-2 confirm-dialog-subtitle">
        {{ data.title | translate: data.interpolateParams | sentancecase }}
      </div>

      <ml-dialog-actions
        [buttonRight]="'yes'"
        (clickLeft)="onCancel()"
        (clickRight)="onConfirm()"
      ></ml-dialog-actions>
    </div>
  